import { render, staticRenderFns } from "./home-box6.vue?vue&type=template&id=50b02fe9&scoped=true&"
import script from "./home-box6.vue?vue&type=script&lang=js&"
export * from "./home-box6.vue?vue&type=script&lang=js&"
import style0 from "./home-box6.vue?vue&type=style&index=0&id=50b02fe9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b02fe9",
  null
  
)

export default component.exports